export const UrlPartType = {
  Static: 'Static',
  Select: 'Select',
  Domain: 'Domain',
  Path: 'Path',
} as const;

export type UrlPartType = (typeof UrlPartType)[keyof typeof UrlPartType];

type Validation = {
  regex: string;
  message: string;
};

type StaticUrlPart = {
  type: typeof UrlPartType.Static;
  value: string;
};

export type SelectUrlPart = {
  type: typeof UrlPartType.Select;
  options: Array<string>;
};

type DomainUrlPart = {
  type: typeof UrlPartType.Domain;
  placeholder: string;
  validation?: Validation;
};

export type PathUrlPart = {
  type: typeof UrlPartType.Path;
  placeholder: string;
  validation?: Validation;
};

export type UrlPart =
  | StaticUrlPart
  | SelectUrlPart
  | DomainUrlPart
  | PathUrlPart;
